import { useTranslation } from 'react-i18next';
import { usePageMetadata } from '@/hooks/usePageMetadata';
import { Paper, Typography, Box } from '@gapartners/ui';
import { QualityMetricsDashboardPage } from '@/pages/quality-metrics/QualityMetricsDashboardPage';

export function QualityMetricsView() {
  const { t } = useTranslation();

  usePageMetadata({
    title: t('pages.manager.qualityMetrics.title'),
    description: t('pages.manager.qualityMetrics.description'),
  });

  return (
    <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography
        variant="h6"
        fontWeight={700}
        color="text.primary"
        gutterBottom
      >
        {t('pages.manager.qualityMetrics.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t('pages.manager.qualityMetrics.description')}
      </Typography>

      {/* Quality Metrics Dashboard */}
      <Box sx={{ mt: 3 }}>
        <QualityMetricsDashboardPage />
      </Box>
    </Paper>
  );
}
